import * as actions from './quiz.actions';
import { ActionType as AT } from './enums/action-type.enum';

import { deepCopy } from '../../utils/library';
import { Service } from '../../models/service.model';
import { Question } from '../../models/question.model';
import { Answer } from '../../models/answer.model';
import { CallTimeFormRegime } from '../../models/call-time-form-regime.model';
import { Result } from './interfaces/result.interface';
import { ConvrTestVariation } from '../../interfaces/convr-test-variation.interface';

type InferValueTypes<T> = T extends { [key: string]: infer U } ? U : never;
type Action = ReturnType<InferValueTypes<typeof actions>>;

class QuizState {
	questions:Question[] = [];
	results:Result[] = [];
	passed = false;
	started = false;
	signUpOpened = false;
	hasPhone = false;
	buttonBackViewStatus = false;
	buttonToCommonViewStatus = false;
	labelViewStatus = true;
	expertViewStatus = false;
	flyingButtonStatus = true;
	currentService:Service | 'selection' = 'selection';
	calculator?: any;
	callTimeFormRegime?: CallTimeFormRegime;
	quizProgress: number = 0;
	serviceListDropdownMenuStatus: boolean = false;
  convrTestVariations: ConvrTestVariation[] = [];
	popupWidth = 0;
	activePopupWindowID?: string;
	popupWindow: boolean = false;
}

export const quizReducer = (state:QuizState = new QuizState(), action:Action):QuizState => {
	switch (action.type) {

		case AT.DEFINE_QUESTIONS: {
			return { ...state, questions: action.payload.questions };
		}

		case AT.CHECK_ANSWER: {
			const target = action.payload;

			const newState:QuizState = deepCopy(state) as QuizState;
			const { answers, type } = newState.questions.find((q) => q.id == target.questionId) || {};

			answers?.forEach((answer:Answer) => {
				if (answer.value == target.value) answer.checked = target.checked;
					else if ((target.checked && mutuallyExclusive(target, answer)) || type == 'radio') {
						answer.checked = false;
					}
			});

			return newState;
		}

		case AT.QUIZ_IS_PASSED: {
			return { ...state, passed: action.payload.status };
		}

		case AT.GET_PHONE: {
			return { ...state, hasPhone: action.payload.status };
		}

		case AT.SET_QUIZ_STARTED: {
			return { ...state, started: action.payload.status };
		}
			
		case AT.SET_SIGN_UP_OPENED: {
			return { ...state, signUpOpened: action.payload.status };
		}

		case AT.UPDATE_CURRENT_SERVICE: {
			return { ...state, currentService: action.payload.service };
		}

		case AT.TOGGLE_BUTTON_BACK: {
			return { ...state, buttonBackViewStatus: action.payload.status };
		}

		case AT.TOGGLE_BUTTON_TO_COMMON: {
			return { ...state, buttonToCommonViewStatus: action.payload.status };
		}

		case AT.ADD_CALCULATOR_DATA: {
			return { ...state, calculator: { ...state.calculator, ...action.payload.data }};
		}

		case AT.SET_CALL_TIME_FORM_REGIME: {
			return { ...state, callTimeFormRegime: action.payload.regime }	
		}

		case AT.ADD_QUIZ_RESULT: {
			return { ...state, results: [...state.results, action.payload.result]};
		}

		case AT.REMOVE_QUIZ_RESULT: {
			return { ...state, results: state.results.filter(result => result.id != action.payload.id)};
		}

		case AT.TOGGLE_DOCTOR: {
			return { ...state, expertViewStatus: action.payload.status };
		}

		case AT.TOGGLE_LABEL: {
			return { ...state, labelViewStatus: action.payload.status };
		}

		case AT.TOGGLE_FLYING_BUTTON: {
			return { ...state, flyingButtonStatus: action.payload.status };
		}

		case AT.SET_QUIZ_PROGRESS: {
			return { ...state, quizProgress: action.payload.progress };
		}

		case AT.TOGGLE_SERVICE_LIST_DROPDOWN_MENU: {
			return { ...state, serviceListDropdownMenuStatus: action.payload.status };
		}

    case AT.SET_CONVR_TEST_VARIATIONS: {
      return { ...state, convrTestVariations: action.payload.variations };
    }

		case AT.SET_POPUP_WIDTH: {
			return { ...state, popupWidth: action.payload.width };
		}

		case AT.DISPLAY_POPUP_WINDOW: {
			return { ...state, popupWindow: action.payload.status };
		}

		case AT.SET_ACTIVE_POPUP_WINDOW_ID: {
			return { ...state, activePopupWindowID: action.payload.id }
		}
		
		default: return state;
	}
};


function mutuallyExclusive(answ1:Pick<Answer, 'reset'>, answ2:Pick<Answer, 'reset'>) {
	return (answ1.reset && !answ2.reset) || (!answ1.reset && answ2.reset);
}